const seamapiReactVersion = null

export default seamapiReactVersion
